const STORAGE_KEY = "auth:token";

/**
 * JWT живёт 7 дней, refresh-токена в API нет by design: при 401 клиент просто
 * логинится заново через `POST /auth/telegram`. Поэтому храним только сам
 * токен, без сложной сессии.
 */
let cached: string | null = null;

export function getToken(): string | null {
  if (cached !== null) return cached;
  try {
    cached = localStorage.getItem(STORAGE_KEY);
  } catch {
    // Приватный режим WebView может запрещать storage. Тогда токен живёт
    // только в памяти — приложение продолжает работать до перезагрузки.
    cached = null;
  }
  return cached;
}

export function setToken(token: string): void {
  cached = token;
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* см. выше */
  }
}

export function clearToken(): void {
  cached = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* см. выше */
  }
}
